// Date 2020-07-22 11:00:00

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/workflow/emActProcessDefinitionRegister/list",
        name: "emActProcessDefinitionRegisterList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/workflow/emActProcessDefinitionRegister/edit",
        name: "emActProcessDefinitionRegisterEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/workflow/emActProcessStatus/list",
        name: "emActProcessStatusList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/workflow/emActProcessStatus/edit",
        name: "emActProcessStatusEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/workflow/emActProcessVariable/list",
        name: "emActProcessVariableList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/workflow/emActProcessVariable/edit",
        name: "emActProcessVariableEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
]